import { localization } from "../localizationManager";

export var russianStrings = {
  groupButton: "Group By Me",
  ungroupButton: "Ungroup By Me",
  selectButton: "Select Me",
  hideColumn: "Hide column",
  showColumn: "Show column",
  makePrivateColumn: "Make column private",
  makePublicColumn: "Make column public",
  moveToDetail: "Move to Detail",
  filter: "Фильтр",
  showAsColumn: "Show as Column",
  visualizer_text: "Texts in table",
  visualizer_wordcloud: "Wordcloud",
  chartType_bar: "Bar",
  chartType_stackedbar: "Stacked Bar",
  chartType_doughnut: "Doughnut",
  chartType_pie: "Pie",
  chartType_scatter: "Scatter",
  chartType_gauge: "Gauge",
  chartType_bullet: "Bullet",
  hideButton: "Скрыть",
  showButton: "Показать",
  resetFilter: "Очистить фильтр",
  changeLocale: "Сменить язык",
  clearButton: "Clear",
  addElement: "Choose question to show...",
  defaultOrder: "Default",
  ascOrder: "Ascending",
  descOrder: "Descending",
  showMinorColumns: "Show minor columns",
  otherCommentTitle: "Другое и комментарии",
  noVisualizerForQuestion: "Этот тип вопроса еще не поддерживается аналитикой",
  noResults: "Результаты отсутствуют"
};

localization.locales["ru"] = russianStrings;
localization.localeNames["ru"] = "Russian";
